export enum ClusterGroupType {
  Geo = 'Geo',
  Org = 'Org',
  GBR = 'GBR',
  General = 'General',
  HoH = 'HoH',
  Are = 'Are',
  ECL = 'ECL'
}
